module.exports = __webpack_public_path__ + "static/media/img-uploader.97e271cd.svg";